import { render, staticRenderFns } from "./DisbursingCollectionInformation.vue?vue&type=template&id=1766dbed&scoped=true"
import script from "./DisbursingCollectionInformation.vue?vue&type=script&lang=js"
export * from "./DisbursingCollectionInformation.vue?vue&type=script&lang=js"
import style0 from "./DisbursingCollectionInformation.vue?vue&type=style&index=0&id=1766dbed&prod&lang=css"
import style1 from "./DisbursingCollectionInformation.vue?vue&type=style&index=1&id=1766dbed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1766dbed",
  null
  
)

export default component.exports